export default __webpack_public_path__ + "static/media/c3.dcb2b21a.png";